import Enums from 'utils/EnumsManager';

const { REDUX_ACTION_TYPE_PREFIX } = Enums;
const { OBJECTDETAILS } = REDUX_ACTION_TYPE_PREFIX;

export const SET_SECTIONS = `${OBJECTDETAILS}_SET_SECTIONS`;
export const SET_ACTIVE_FIELD = `${OBJECTDETAILS}_SET_ACTIVE_FIELD`;
export const RESET_ACTIVE_FIELD = `${OBJECTDETAILS}_RESET_ACTIVE_FIELD`;
export const SET_FIELD_VALUE = `${OBJECTDETAILS}_SET_FIELD_VALUE`;
export const RESET_FIELD_VALUE = `${OBJECTDETAILS}_RESET_FIELD_VALUE`;
export const RESET_ALL_FIELDS = `${OBJECTDETAILS}_RESET_ALL_FIELDS`;
export const SET_NEW_ID = `${OBJECTDETAILS}_SET_NEW_ID`;
export const RESET_ID = `${OBJECTDETAILS}_RESET_ID`;
export const RESET = `${OBJECTDETAILS}_RESET`;
export const SET_FIELD_OPTIONS = `${OBJECTDETAILS}_SET_FIELD_OPTIONS`;
export const SET_ACCOUNT_NAME = `${OBJECTDETAILS}_SET_ACCOUNT_NAME`;
export const SET_SHARED_STATUS = `${OBJECTDETAILS}_SET_SHARED_STATUS`;
export const RESET_SHARED = `${OBJECTDETAILS}_RESET_SHARED`;
export const RESET_SECTIONS = `${OBJECTDETAILS}_RESET_SECTIONS`;



// WEBPACK FOOTER //
// ./src/components/page/PrimaryDetails/flow/actionTypes.js